/* eslint-disable @typescript-eslint/consistent-type-definitions, id-denylist, @typescript-eslint/sort-type-union-intersection-members -- generated type definition */

/*
 * DO NOT EDIT!
 * This file was autogenerated by graphql-codegen.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 *
 * Run `yarn run codegen` to regenerate.
 */

/** All built-in and custom scalars, mapped to their actual values */

/** Customers address */

/** Customers address metadata */

/** Enum allowed search results */
export var AddressMetadataAllowedSearchResults;
/** Delivery */

(function (AddressMetadataAllowedSearchResults) {
  AddressMetadataAllowedSearchResults["Area"] = "Area";
  AddressMetadataAllowedSearchResults["City"] = "City";
  AddressMetadataAllowedSearchResults["Country"] = "Country";
  AddressMetadataAllowedSearchResults["District"] = "District";
  AddressMetadataAllowedSearchResults["Locality"] = "Locality";
  AddressMetadataAllowedSearchResults["Market"] = "Market";
  AddressMetadataAllowedSearchResults["Province"] = "Province";
  AddressMetadataAllowedSearchResults["Region"] = "Region";
  AddressMetadataAllowedSearchResults["Street"] = "Street";
  AddressMetadataAllowedSearchResults["ZipCode"] = "ZipCode";
})(AddressMetadataAllowedSearchResults || (AddressMetadataAllowedSearchResults = {}));

/** Enum address type */
export var AddressType;
/** Group of application resources */

(function (AddressType) {
  AddressType["Channel"] = "Channel";
  AddressType["Delivery"] = "Delivery";
  AddressType["Foreign"] = "Foreign";
  AddressType["Home"] = "Home";
  AddressType["Kyc"] = "Kyc";
  AddressType["Other"] = "Other";
})(AddressType || (AddressType = {}));

export var ArticleType;

(function (ArticleType) {
  ArticleType["BeautyEdit"] = "BeautyEdit";
  ArticleType["RelatedToProduct"] = "RelatedToProduct";
  ArticleType["Undefined"] = "Undefined";
})(ArticleType || (ArticleType = {}));

/** Channel to identify how we should notify user */
export var BackInStockNotificationChannel;
/** Input to let user subscribe to when the product is back in stock */

(function (BackInStockNotificationChannel) {
  BackInStockNotificationChannel["Email"] = "Email";
  BackInStockNotificationChannel["Sms"] = "Sms";
})(BackInStockNotificationChannel || (BackInStockNotificationChannel = {}));

/** Background types */
export var BackgroundType;

(function (BackgroundType) {
  BackgroundType["Color"] = "Color";
  BackgroundType["Image"] = "Image";
  BackgroundType["None"] = "None";
  BackgroundType["Video"] = "Video";
})(BackgroundType || (BackgroundType = {}));

export var CatalogueOfferType;

(function (CatalogueOfferType) {
  CatalogueOfferType["Buy"] = "Buy";
  CatalogueOfferType["Choose"] = "Choose";
  CatalogueOfferType["ChooseAndChoose"] = "ChooseAndChoose";
  CatalogueOfferType["ChooseAndGet"] = "ChooseAndGet";
  CatalogueOfferType["Get"] = "Get";
  CatalogueOfferType["None"] = "None";
})(CatalogueOfferType || (CatalogueOfferType = {}));

export var ChannelType;

(function (ChannelType) {
  ChannelType["Mv7"] = "MV7";
  ChannelType["Website"] = "Website";
})(ChannelType || (ChannelType = {}));

export var ChatBotMode;
/** Color type */

(function (ChatBotMode) {
  ChatBotMode["AlwaysEnabled"] = "AlwaysEnabled";
  ChatBotMode["Disabled"] = "Disabled";
  ChatBotMode["NonBusinessHoursOnly"] = "NonBusinessHoursOnly";
})(ChatBotMode || (ChatBotMode = {}));

export var ColorType;
/** Concept of products */

(function (ColorType) {
  ColorType["Brown"] = "Brown";
  ColorType["Green"] = "Green";
  ColorType["White"] = "White";
})(ColorType || (ColorType = {}));

/** Enum customer category */
export var CustomerCategory;
/** Customer type */

(function (CustomerCategory) {
  CustomerCategory["Anonymous"] = "Anonymous";
  CustomerCategory["Consultant"] = "Consultant";
  CustomerCategory["Employee"] = "Employee";
  CustomerCategory["EndConsumer"] = "EndConsumer";
  CustomerCategory["EndCustomer"] = "EndCustomer";
  CustomerCategory["Invitation"] = "Invitation";
  CustomerCategory["Other"] = "Other";
})(CustomerCategory || (CustomerCategory = {}));

/** eWallet type */
export var EWalletType;
/** Editorial banner */

(function (EWalletType) {
  EWalletType["Revolut"] = "Revolut";
})(EWalletType || (EWalletType = {}));

/** Editorial banner layout enumeration */
export var EditorialBannerLayoutEnum;

(function (EditorialBannerLayoutEnum) {
  EditorialBannerLayoutEnum["FourMedia"] = "FourMedia";
  EditorialBannerLayoutEnum["Headline"] = "Headline";
  EditorialBannerLayoutEnum["OneMediaCenterBottomText"] = "OneMediaCenterBottomText";
  EditorialBannerLayoutEnum["OneMediaOverlayLeftText"] = "OneMediaOverlayLeftText";
  EditorialBannerLayoutEnum["OneMediaOverlayRightText"] = "OneMediaOverlayRightText";
  EditorialBannerLayoutEnum["OneMediaParagraphText"] = "OneMediaParagraphText";
  EditorialBannerLayoutEnum["OneMediaProductPromo"] = "OneMediaProductPromo";
  EditorialBannerLayoutEnum["ParagraphText"] = "ParagraphText";
  EditorialBannerLayoutEnum["Quote"] = "Quote";
  EditorialBannerLayoutEnum["ThreeMediaRightBottomText"] = "ThreeMediaRightBottomText";
  EditorialBannerLayoutEnum["TwoMedia"] = "TwoMedia";
  EditorialBannerLayoutEnum["TwoMediaRightTopText"] = "TwoMediaRightTopText";
  EditorialBannerLayoutEnum["Video"] = "Video";
})(EditorialBannerLayoutEnum || (EditorialBannerLayoutEnum = {}));

/** Editorial banner title color enumeration */
export var EditorialBannerTitleColorEnum;
/** Editorial banner title size enumeration */

(function (EditorialBannerTitleColorEnum) {
  EditorialBannerTitleColorEnum["Black"] = "Black";
  EditorialBannerTitleColorEnum["DarkGrey"] = "DarkGrey";
  EditorialBannerTitleColorEnum["White"] = "White";
})(EditorialBannerTitleColorEnum || (EditorialBannerTitleColorEnum = {}));

export var EditorialBannerTitleSizeEnum;
/** Representation of a carousel containing editorial page banners */

(function (EditorialBannerTitleSizeEnum) {
  EditorialBannerTitleSizeEnum["H5"] = "H5";
  EditorialBannerTitleSizeEnum["H6"] = "H6";
})(EditorialBannerTitleSizeEnum || (EditorialBannerTitleSizeEnum = {}));

/** Editorial channel type */
export var EditorialChannelType;
/** Editorial header */

(function (EditorialChannelType) {
  EditorialChannelType["Mobile"] = "Mobile";
  EditorialChannelType["Web"] = "Web";
})(EditorialChannelType || (EditorialChannelType = {}));

/** Editorial PLP banner size */
export var EditorialPlpPromoBannerSize;
/** Product listing page row */

(function (EditorialPlpPromoBannerSize) {
  EditorialPlpPromoBannerSize["Size1"] = "Size1";
  EditorialPlpPromoBannerSize["Size2"] = "Size2";
})(EditorialPlpPromoBannerSize || (EditorialPlpPromoBannerSize = {}));

/** Feedback Benefit Banner type */
export var FeedbackBenefitBannerType;

(function (FeedbackBenefitBannerType) {
  FeedbackBenefitBannerType["Cashback"] = "Cashback";
  FeedbackBenefitBannerType["ShareAndEarn"] = "ShareAndEarn";
})(FeedbackBenefitBannerType || (FeedbackBenefitBannerType = {}));

/** Enum gender */
export var Gender;

(function (Gender) {
  Gender["Man"] = "Man";
  Gender["Other"] = "Other";
  Gender["Woman"] = "Woman";
})(Gender || (Gender = {}));

/** Enum language type */
export var LanguageType;

(function (LanguageType) {
  LanguageType["Alternative"] = "Alternative";
  LanguageType["Default"] = "Default";
})(LanguageType || (LanguageType = {}));

export var MobileAppType;
/** Type of mobile app */

(function (MobileAppType) {
  MobileAppType["None"] = "None";
  MobileAppType["ToSell"] = "ToSell";
  MobileAppType["ToShop"] = "ToShop";
})(MobileAppType || (MobileAppType = {}));

/** Possible types of Navigation items */
export var NavigationLinkType;
/** Navigationag type definition */

(function (NavigationLinkType) {
  NavigationLinkType["AllCategory"] = "AllCategory";
  NavigationLinkType["Bottom"] = "Bottom";
  NavigationLinkType["BottomCopyright"] = "BottomCopyright";
  NavigationLinkType["BottomLinks"] = "BottomLinks";
  NavigationLinkType["Catalogue"] = "Catalogue";
  NavigationLinkType["Catalogues"] = "Catalogues";
  NavigationLinkType["Category"] = "Category";
  NavigationLinkType["DigitalCatalogueCurrent"] = "DigitalCatalogueCurrent";
  NavigationLinkType["DigitalCatalogueNext"] = "DigitalCatalogueNext";
  NavigationLinkType["FocusPage"] = "FocusPage";
  NavigationLinkType["FooterColumn"] = "FooterColumn";
  NavigationLinkType["FooterColumnItem"] = "FooterColumnItem";
  NavigationLinkType["IDontKnowYet"] = "IDontKnowYet";
  NavigationLinkType["Inspiration"] = "Inspiration";
  NavigationLinkType["JoinRewards"] = "JoinRewards";
  NavigationLinkType["KeyIngredients"] = "KeyIngredients";
  NavigationLinkType["MenuTiles"] = "MenuTiles";
  NavigationLinkType["New"] = "New";
  NavigationLinkType["None"] = "None";
  NavigationLinkType["OurApps"] = "OurApps";
  NavigationLinkType["OutletShop"] = "OutletShop";
  NavigationLinkType["PaymentMethod"] = "PaymentMethod";
  NavigationLinkType["PaymentMethods"] = "PaymentMethods";
  NavigationLinkType["PopularBrand"] = "PopularBrand";
  NavigationLinkType["PopularBrands"] = "PopularBrands";
  NavigationLinkType["PopularLookbook"] = "PopularLookbook";
  NavigationLinkType["Qrtr"] = "QRTR";
  NavigationLinkType["RewardsShop"] = "RewardsShop";
  NavigationLinkType["SampleShop"] = "SampleShop";
  NavigationLinkType["Segment"] = "Segment";
  NavigationLinkType["SubCategory"] = "SubCategory";
  NavigationLinkType["SupportCenter"] = "SupportCenter";
  NavigationLinkType["TopNavigation"] = "TopNavigation";
  NavigationLinkType["WhatsNewInCategory"] = "WhatsNewInCategory";
})(NavigationLinkType || (NavigationLinkType = {}));

/** Possible types of navigations */
export var NavigationType;

(function (NavigationType) {
  NavigationType["AboutTiles"] = "AboutTiles";
  NavigationType["Footer"] = "Footer";
  NavigationType["InspirationTiles"] = "InspirationTiles";
  NavigationType["JoinTiles"] = "JoinTiles";
  NavigationType["ShopSection"] = "ShopSection";
  NavigationType["TopNavigation"] = "TopNavigation";
})(NavigationType || (NavigationType = {}));

export var NotificationBannerThemeType;

(function (NotificationBannerThemeType) {
  NotificationBannerThemeType["Black"] = "Black";
  NotificationBannerThemeType["Grey"] = "Grey";
})(NotificationBannerThemeType || (NotificationBannerThemeType = {}));

/** Olapic type enumeration */
export var OlapicTypeEnum;
/** Navigation menu for a single page */

(function (OlapicTypeEnum) {
  OlapicTypeEnum["Category"] = "Category";
  OlapicTypeEnum["FrontPage"] = "FrontPage";
  OlapicTypeEnum["Gallery"] = "Gallery";
  OlapicTypeEnum["ProductDetails"] = "ProductDetails";
})(OlapicTypeEnum || (OlapicTypeEnum = {}));

/** Products order strategies */
export var PlpOrderBy;
/** Definition of possible products ordering strategy */

(function (PlpOrderBy) {
  PlpOrderBy["HighestDiscount"] = "HighestDiscount";
  PlpOrderBy["HighestPrice"] = "HighestPrice";
  PlpOrderBy["HighestRating"] = "HighestRating";
  PlpOrderBy["Latest"] = "Latest";
  PlpOrderBy["LowestPrice"] = "LowestPrice";
  PlpOrderBy["Recommended"] = "Recommended";
})(PlpOrderBy || (PlpOrderBy = {}));

/** Product Label Domain Type */
export var ProductLabelDomainType;
/** Product list of specified product type, for example: Personal, Favorite ... */

(function (ProductLabelDomainType) {
  ProductLabelDomainType["Deal"] = "Deal";
  ProductLabelDomainType["Ppa"] = "PPA";
  ProductLabelDomainType["Shopping"] = "Shopping";
})(ProductLabelDomainType || (ProductLabelDomainType = {}));

export var ProductListType;
/** Product listing banner */

(function (ProductListType) {
  ProductListType["Favorite"] = "Favorite";
  ProductListType["Personal"] = "Personal";
  ProductListType["Private"] = "Private";
  ProductListType["Wishlist"] = "Wishlist";
})(ProductListType || (ProductListType = {}));

/** Enum ProductListingBannerVideoType */
export var ProductListingBannerVideoType;
/** Product Listing Page */

(function (ProductListingBannerVideoType) {
  ProductListingBannerVideoType["Mp4"] = "Mp4";
  ProductListingBannerVideoType["None"] = "None";
  ProductListingBannerVideoType["Youku"] = "Youku";
  ProductListingBannerVideoType["Youtube"] = "Youtube";
})(ProductListingBannerVideoType || (ProductListingBannerVideoType = {}));

/** Relation types */
export var ProductRelationEnum;

(function (ProductRelationEnum) {
  ProductRelationEnum["RecentlyViewed"] = "RecentlyViewed";
  ProductRelationEnum["Related"] = "Related";
})(ProductRelationEnum || (ProductRelationEnum = {}));

export var ProductType;
/** Query root */

(function (ProductType) {
  ProductType["Bundle"] = "Bundle";
  ProductType["Composite"] = "Composite";
  ProductType["Fee"] = "Fee";
  ProductType["Product"] = "Product";
  ProductType["Sample"] = "Sample";
})(ProductType || (ProductType = {}));

/** ResponseMessageNewsletterSubsciptionsType */
export var ResponseMessageNewsletterSubsciptionsType;

(function (ResponseMessageNewsletterSubsciptionsType) {
  ResponseMessageNewsletterSubsciptionsType["Cleaned"] = "Cleaned";
  ResponseMessageNewsletterSubsciptionsType["New"] = "New";
  ResponseMessageNewsletterSubsciptionsType["Pending"] = "Pending";
  ResponseMessageNewsletterSubsciptionsType["Subscribed"] = "Subscribed";
  ResponseMessageNewsletterSubsciptionsType["Unsubscribed"] = "Unsubscribed";
})(ResponseMessageNewsletterSubsciptionsType || (ResponseMessageNewsletterSubsciptionsType = {}));

export var SettingsClientType;

(function (SettingsClientType) {
  SettingsClientType["OnlineReportingGrid"] = "OnlineReportingGrid";
  SettingsClientType["WellnessClub"] = "WellnessClub";
})(SettingsClientType || (SettingsClientType = {}));

export var SettingsFormatType;
/** Share and earn page template */

(function (SettingsFormatType) {
  SettingsFormatType["Json"] = "Json";
  SettingsFormatType["String"] = "String";
  SettingsFormatType["Xml"] = "Xml";
})(SettingsFormatType || (SettingsFormatType = {}));

/** Live video show type */
export var ShowType;
/** Sized image wariant */

(function (ShowType) {
  ShowType["Ended"] = "Ended";
  ShowType["Live"] = "Live";
  ShowType["Scheduled"] = "Scheduled";
})(ShowType || (ShowType = {}));

/** Types of social contact */
export var SocialContactType;
/** SocialMediaLinks type */

(function (SocialContactType) {
  SocialContactType["Email"] = "Email";
  SocialContactType["Facebook"] = "Facebook";
  SocialContactType["PhoneNumber"] = "PhoneNumber";
  SocialContactType["VKontakte"] = "VKontakte";
  SocialContactType["WeChat"] = "WeChat";
  SocialContactType["WhatsUpNumber"] = "WhatsUpNumber";
})(SocialContactType || (SocialContactType = {}));

/** Types of social media */
export var SocialMediaType;
/** Sponsor */

(function (SocialMediaType) {
  SocialMediaType["Facebook"] = "Facebook";
  SocialMediaType["Instagram"] = "Instagram";
  SocialMediaType["Line"] = "Line";
  SocialMediaType["Odnoklassniki"] = "Odnoklassniki";
  SocialMediaType["Pinterest"] = "Pinterest";
  SocialMediaType["Qq"] = "QQ";
  SocialMediaType["Telegram"] = "Telegram";
  SocialMediaType["Twitter"] = "Twitter";
  SocialMediaType["VKontakte"] = "VKontakte";
  SocialMediaType["WeChat"] = "WeChat";
  SocialMediaType["Weibo"] = "Weibo";
  SocialMediaType["YouTube"] = "YouTube";
  SocialMediaType["Youku"] = "Youku";
})(SocialMediaType || (SocialMediaType = {}));

/** Sponsor type */
export var SponsorType;
/** Colors enum referring to FE storybook */

(function (SponsorType) {
  SponsorType["DirectSponsor"] = "DirectSponsor";
})(SponsorType || (SponsorType = {}));

export var StorybookColor;
/** SubmitDialogNewsletterSubsciptionConfiguration */

(function (StorybookColor) {
  StorybookColor["Blue100"] = "Blue100";
  StorybookColor["Brown50"] = "Brown50";
  StorybookColor["Brown300"] = "Brown300";
  StorybookColor["Brown400"] = "Brown400";
  StorybookColor["DefaultContrastText"] = "DefaultContrastText";
  StorybookColor["Green400"] = "Green400";
  StorybookColor["Grey50"] = "Grey50";
  StorybookColor["InfoDark"] = "InfoDark";
  StorybookColor["Pink50"] = "Pink50";
  StorybookColor["Pink300"] = "Pink300";
  StorybookColor["PrimaryLight"] = "PrimaryLight";
  StorybookColor["Purple50"] = "Purple50";
  StorybookColor["Purple200"] = "Purple200";
  StorybookColor["Purple400"] = "Purple400";
  StorybookColor["Red50"] = "Red50";
  StorybookColor["SecondaryMain"] = "SecondaryMain";
  StorybookColor["TextPrimary"] = "TextPrimary";
  StorybookColor["TextSecondary"] = "TextSecondary";
  StorybookColor["Undefined"] = "Undefined";
  StorybookColor["Yellow50"] = "Yellow50";
  StorybookColor["Yellow400"] = "Yellow400";
})(StorybookColor || (StorybookColor = {}));

/** Enum telephone type */
export var TelephoneType;

(function (TelephoneType) {
  TelephoneType["Business"] = "Business";
  TelephoneType["Fax"] = "Fax";
  TelephoneType["Home"] = "Home";
  TelephoneType["Mobile"] = "Mobile";
})(TelephoneType || (TelephoneType = {}));

/** Content vertical alignment */
export var VerticalContentAlignment;

(function (VerticalContentAlignment) {
  VerticalContentAlignment["Bottom"] = "Bottom";
  VerticalContentAlignment["Middle"] = "Middle";
  VerticalContentAlignment["Top"] = "Top";
  VerticalContentAlignment["Undefined"] = "Undefined";
})(VerticalContentAlignment || (VerticalContentAlignment = {}));

export var VideoType;

(function (VideoType) {
  VideoType["Mp4"] = "Mp4";
  VideoType["Youku"] = "Youku";
  VideoType["Youtube"] = "Youtube";
})(VideoType || (VideoType = {}));

/** Possible types of visitor segment */
export var VisitorSegment;
/** Group of Wellness Club resources */

(function (VisitorSegment) {
  VisitorSegment["Anonymous"] = "Anonymous";
  VisitorSegment["Consultant"] = "Consultant";
  VisitorSegment["DirectorAndAbove"] = "DirectorAndAbove";
  VisitorSegment["EndCustomer"] = "EndCustomer";
  VisitorSegment["Manager"] = "Manager";
  VisitorSegment["Member"] = "Member";
  VisitorSegment["NewConsultant"] = "NewConsultant";
  VisitorSegment["NotDefined"] = "NotDefined";
  VisitorSegment["Spo"] = "Spo";
})(VisitorSegment || (VisitorSegment = {}));